import { Message } from 'element-ui'
import router from '@/router'
import { clearUserSession } from '@/utils/auth'

let isHandlingAuthExpired = false

export function isAuthExpiredError(error) {
  const response = error && error.response ? error.response : null
  const responseData = response && response.data ? response.data : null
  const message = responseData && responseData.message
    ? responseData.message
    : (error && error.message ? error.message : '')

  return response && (response.status === 401 || response.status === 302)
    || message === 'Unauthenticated.'
}

export function handleAuthExpired(options = {}) {
  const { onResetStore } = options

  clearUserSession()
  if (typeof onResetStore === 'function') {
    onResetStore()
  }

  if (isHandlingAuthExpired) {
    return
  }

  isHandlingAuthExpired = true
  Message({
    message: '登录已过期，请重新登录',
    type: 'warning',
    duration: 3 * 1000
  })

  if (!router.currentRoute || router.currentRoute.path !== '/login') {
    router.replace('/login')
  }

  window.setTimeout(() => {
    isHandlingAuthExpired = false
  }, 1000)
}
